
//export const base_url = 'http://localhost:3000/'; 
export const base_url = 'https://coolpro.ae/'; 
export const api_base_url = 'https://coolpro.ae/app/public/api/'; 
//export const api_base_url = 'https://coolpro.revezsoft.co.in/public/api/'; 